import { render, staticRenderFns } from "./pageAction.vue?vue&type=template&id=5665a2ba"
import script from "./pageAction.vue?vue&type=script&lang=js"
export * from "./pageAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports